import { Light as SyntaxHighlighter } from "react-syntax-highlighter";
import bash from "react-syntax-highlighter/dist/cjs/languages/hljs/bash";
import css from "react-syntax-highlighter/dist/cjs/languages/hljs/css";
import javascript from "react-syntax-highlighter/dist/cjs/languages/hljs/javascript";
import json from "react-syntax-highlighter/dist/cjs/languages/hljs/json";
import objectivec from "react-syntax-highlighter/dist/cjs/languages/hljs/objectivec";
import php from "react-syntax-highlighter/dist/cjs/languages/hljs/php";
import python from "react-syntax-highlighter/dist/cjs/languages/hljs/python";
import scss from "react-syntax-highlighter/dist/cjs/languages/hljs/scss";
import swift from "react-syntax-highlighter/dist/cjs/languages/hljs/swift";
import typescript from "react-syntax-highlighter/dist/cjs/languages/hljs/typescript";
import yaml from "react-syntax-highlighter/dist/cjs/languages/hljs/yaml";

SyntaxHighlighter.registerLanguage("bash", bash);
SyntaxHighlighter.registerLanguage("javascript", javascript);
SyntaxHighlighter.registerLanguage("groq", javascript);
SyntaxHighlighter.registerLanguage("typescript", typescript);
SyntaxHighlighter.registerLanguage("python", python);
SyntaxHighlighter.registerLanguage("json", json);
SyntaxHighlighter.registerLanguage("php", php);
SyntaxHighlighter.registerLanguage("swift", swift);
SyntaxHighlighter.registerLanguage("objectivec", objectivec);
SyntaxHighlighter.registerLanguage("yaml", yaml);
SyntaxHighlighter.registerLanguage("css", css);
SyntaxHighlighter.registerLanguage("scss", scss);

export default SyntaxHighlighter;
